<article class="course-section-sub-domain-container">
  <div class="course-section-sub-domain">
    <app-course-section-details-side-menu></app-course-section-details-side-menu>
    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
